export const inProduction = true;
export const showEkatenaView = false;

export const version = '1.0';

export const ekatenaURL = inProduction ? 'https://sandbox-api.ekatena.com' : 'https://sandbox-api.ekatena.com';

export const apiURL = inProduction ? 'https://cotizaws.abcleasing.com.mx:63748/api' : 'https://cotizawstest.finbeabc.com.mx/api';

export const ekatenaBasicAuth = 'UG1XYjlUZE5hYURDWTBvZmlwVjVhSmtzZ0xfc1YxTUpQLWoxdjNhOFlFZzpkV0pWS3JyV2JGWndSanVDMjZITmpPQ1VVcHdLR0lQWlkzdjNEZkZScWNz';

export const RegexRFCMoral =    new RegExp("^(([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
"(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
"(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
"(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$");

export const RegexRFCFisica =   new RegExp("^(([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
"(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
"(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
"(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$");

export enum Colors {
    blue = '#333F48',
    blue40 = 'rgba(51,63,72,0.4)',
    blue10 = 'rgba(51,63,72,0.1)',

    orange = '#D45D00',
    orange40 = 'rgba(212,93,0,0.4)',

    yellow = '#FFC72C',
    yellow40 = 'rgba(255,199,44,0.4)',

    lightGrey = '#EAEBEC',
    darkGrey = '#D5D8DA',
}

export enum Fonts {
    sspBold = 'SweetSansPro-Bold',
    sspHeavy = 'SweetSansPro-Heavy', 
    sspLight = 'SweetSansPro-Light',
    sspMedium = 'SweetSansPro-Medium',
    sspRegular = 'SweetSansPro-Regular',
    sspThin = 'SweetSansPro-Thin',

    robotoBold = 'roboto bold',
    robotoCondensed = 'roboto condensed',
    robotoLight = 'roboto light',
    robotoMedium = 'roboto medium',
    robotoRegular = 'roboto regular',
    robotoThin = 'roboto thin',
}
